export default __webpack_public_path__ + "static/media/pic8.5b4de4a1.jpg";